import { render } from "./ModalBuscarObjetos.vue?vue&type=template&id=41b2f1c8&scoped=true"
import script from "./ModalBuscarObjetos.vue?vue&type=script&lang=js"
export * from "./ModalBuscarObjetos.vue?vue&type=script&lang=js"

import "./ModalBuscarObjetos.vue?vue&type=style&index=0&id=41b2f1c8&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b2f1c8"]])

export default __exports__